import {
  ArticleFieldsFragment,
  CategoryFieldsFragment,
  LanguageId,
  TranslationTitle,
} from 'lib-knowledge-management-common/graphql';

import { DEFAULT_LANG_CODE } from './constants';

// TODO: these aren't really utils
const matchesLanguageId =
  (langId = DEFAULT_LANG_CODE) =>
  (title: TranslationTitle): boolean =>
    title.languageId === langId;

type Titles =
  | CategoryFieldsFragment['titles']
  | ArticleFieldsFragment['titles'];

export const getFirstLanguage = (titles: Titles): Titles[number] => {
  if (titles.length === 0) {
    throw new Error('No titles provided');
  }
  return titles[0];
};

export const hasDefaultLanguageTitle = (
  titles: Titles,
  defaultLanguageId: LanguageId,
): boolean => {
  return titles.some(matchesLanguageId(defaultLanguageId));
};

export const noop = (): void => undefined;
